import { Typography } from '@euler/app/components/typography';
import { Icon } from '@euler/components/Icomoon';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { MotiView } from 'moti';
import { memo } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';

const kHeight = 56;

export const ConstructionJobTechnicianPicker = memo(
  ({
    technicianName,
    style,
    editable,
    onPress,
  }: {
    technicianName: string;
    editable?: boolean;
    style?: StyleProp<ViewStyle>;
    onPress?: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <MotiView
        from={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ overshootClamping: true }}
        css={`
          background-color: #fff;
          height: ${rpx(kHeight)}px;
          border-radius: ${rpx(kHeight) / 2}px;
          box-shadow: 0 0 ${rpx(5)}px rgba(0, 0, 0, 0.25);
          elevation: 5;
        `}
        style={style}
      >
        <TouchableOpacity
          onPress={editable ? onPress : undefined}
          activeOpacity={editable ? undefined : 1}
        >
          <HStack
            css={`
              height: ${rpx(kHeight)}px;
              border-radius: ${rpx(kHeight) / 2}px;
              background-color: #fff;
              padding: 0 ${rpx(kHeight) / 2}px;
            `}
          >
            <Typography.Label>
              <Typography.Label size={rpx(20)} light>
                施工技师:{' '}
              </Typography.Label>
              <Typography.Label size={rpx(20)} light color={'#207FE7'}>
                {technicianName}
              </Typography.Label>
            </Typography.Label>
            {editable && (
              <HStack>
                <Typography.Label
                  color="#aaa"
                  light
                  size={rpx(14)}
                  css={`
                    margin-right: ${rpx(4)}px;
                  `}
                >
                  (下拉选择)
                </Typography.Label>
                <Icon name="chevron-down" size={rpx(28)} color={'#207FE7'} />
              </HStack>
            )}
          </HStack>
        </TouchableOpacity>
      </MotiView>
    );
  },
);
